// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"138":"874568b1","439":"37e18473","557":"cfd998e8","775":"de411de7"}[chunkId] + ".chunk.js";
};